<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row justify-content-center">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex mx-lg-0">
              <!-- 2단계 카드가 길어지면 cover 그림이 커져 오른쪽 휴대폰이 잘린다 — 2단계에서는 그림 전체가 보이게 -->
              <div
                class="position-relative bg-gradient-primary h-100 border-radius-lg d-flex justify-content-center overflow-hidden newbg w-100"
                :class="{ 'newbg-fit': twoFactor }"
              >
              <span class="mask opacity-6"></span>
            </div>
          </div>
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 border-radius-lg"
              style="border: solid 1px black;"
            >
              <div class="signinBox">
                <div class="pb-0 card-header newlogin text-center">
                  <h4 class="font-weight-bolder">서티라이프 운영 페이지</h4>
                  <p class="mb-5">서티라이프 서비스 담당자 외의 접근은 차단합니다.</p>
                </div>
                <!-- 2단계: 등록된 휴대폰·이메일로 받은 인증번호 확인(REQ-MFA-012).
                     수단이 없으면 첫 로그인 등록 단계(TWO_FACTOR_ENROLL_REQUIRED, REQ-MFA-003) -->
                <div v-if="twoFactor" class="card-body signin-otp">
                  <div class="signin-otp-title">
                    {{ twoFactor.enroll ? "2차 인증 등록" : "2차 인증" }}
                    <span class="signin-otp-user">{{ email.trim() }}</span>
                  </div>
                  <p class="signin-otp-desc">{{ twoFactor.enroll
                    ? "운영자 계정은 2차 인증 등록이 필요합니다. 휴대폰 또는 이메일을 등록해 주세요."
                    : "로그인을 마치려면 등록된 휴대폰이나 이메일로 받은 인증번호를 입력하세요." }}</p>
                  <otp-step
                    :key="twoFactor.enroll ? 'enroll' : 'verify'"
                    :methods="twoFactor.methods"
                    :targets="twoFactor.targets"
                    :enroll="twoFactor.enroll"
                    :send="sendTwoFactorCode"
                    :verify="verifyTwoFactorCode"
                    :submit-text="twoFactor.enroll ? '등록하고 로그인' : '로그인'"
                  >
                    <a-button block class="signin-otp-cancel" @click="cancelTwoFactor">
                      처음부터 다시 로그인
                    </a-button>
                  </otp-step>
                </div>
                <div v-else class="card-body">
                  <a-alert v-if="geoNotice" class="mb-3" type="warning" show-icon :message="geoNotice" description="국외 예외나 허용 IP 가 승인된 계정은 그대로 로그인할 수 있습니다." />
                  <div class="mb-3 d-flex align-items-center">
                    <span style="width:10%">ID</span>
                    <input
                    class="loginInput"
                    type="email"
                    placeholder="서티라이프 계정을 입력해주세요(henry@certilife.co)"
                    v-model="email"
                    />
                  </div>
                  <div class="mb-3 d-flex flex-direction-row align-items-center">
                    <span style="width:10%">PW</span>
                    <input
                      class="loginInput"
                      type="password"
                      placeholder="비밀번호를 입력하세요"
                      v-model="password"
                      @keyup.enter="enter()"
                    />
                  </div>

                  <div class="text-center d-flex flex-direction-row align-items-center">
                    <span style="width:10%"/>
                    <button
                      class="mt-4 btn btn-primary"
                      color="success"
                      fullWidth
                      @click="signIn()"
                    >
                      로그인
                    </button>
                  </div>
                  <div class="text-center d-flex flex-direction-row align-items-center">
                    <span style="width:10%"/>
                    <div class="loginResult mt-4">
                      {{ loginError }}
                    </div>
                  </div>
                </div>
    
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import {jwtDecoder, openDialog } from "../utils/utils";
import { GEO_BLOCKED_MESSAGE, clearMfaToken, errorCode, errorMessage, setMfaToken, usableMethods } from "../utils/mfa";
import { standardErrorNotice } from "../utils/standardErrors";
import OtpStep from "./components/OtpStep.vue";
import { reportGeoBlock } from "../utils/geoBlockReport";
import { nextLoginGeneration, resetAsked } from "../utils/permReview";

const body = document.getElementsByTagName("body")[0];

// 옛 서버의 공용 비밀번호 거절(운영자 + 수단 없음, D-112) — 비밀번호 틀림과 같은 문구. 공용 비밀번호가 맞았는지 화면으로 알 수 없게(11-01, 새 서버는 LOGIN_FAILED 로 보냄)
const SHARED_PASSWORD_LOGIN_MESSAGE =
  "아이디 또는 비밀번호가 맞지 않습니다.";

export default {
  name: "signIn",
  components: {
    OtpStep,
  },
  data() {
    return {
      email: "",
      password: "",
      role: "CERTILIFE",
      loginError: "", // 로그인 화면에 남기는 실패 문구(국외 차단·잠금·남은 횟수 등)
      twoFactor: null, // 2단계·등록 진행 중이면 { token, methods, targets, enroll }
      geoNotice: "", // 국외 접속 안내(로그인 전 geo-check 결과). 빈 문자열이면 숨김
    };
  },
  // 로그인 전 국외 판정 한 번(enforce·국외면 blocked. 토큰 없이 불러 계정 예외는 모름 — 안내에 예외 계정 한 줄을 덧붙임). 실패는 조용히 무시 — 실제 차단은 서버가 함
  async mounted() {
    try {
      const { data, config } = await this.$apiInstance.get("/auth/geo-check", {
        showGlobalLoading: false,
        showErrorNotice: false,
      });
      if (data && data.blocked === true) {
        this.geoNotice = `${GEO_BLOCKED_MESSAGE}${data.ip ? ` (접속 IP: ${data.ip})` : ""}`;
        reportGeoBlock("PAGE_OPEN", config);
      }
    } catch (e) {
      // 판정 API 미배포·네트워크 오류는 안내하지 않음
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-white-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-white-100");
  },
  methods: {
    // 주요 API

    // 로그인
    async signIn() {
      this.loginError = "";
      try {
        const email = this.email.trim();
        const response = await this.$apiInstance.post(
          `/auth/login`,
          {
            username: email,
            password: this.password,
            role: this.role
          },
          // 실패 문구는 화면 안 loginError 로만 보인다(인터셉터 토스트와 겹침 방지)
          { showErrorNotice: false }
        );

        if (response.status === 200 || response.status === 201) {
          const { data } = response;
          if (data.code === "TWO_FACTOR_ENROLL_REQUIRED" || data.enrollRequired) {
            this.startEnroll(data);
            return;
          }
          if (data.code === "TWO_FACTOR_REQUIRED" || data.twoFactorRequired) {
            this.startTwoFactor(data);
            return;
          }
          await this.completeLogin(data);
        } else {
          this.loginError = "로그인에 실패하였습니다.";
        }
      } catch (error) {
        console.log(error);
        // LOGIN_FAILED·ACCOUNT_LOCKED 는 code 별 문구, SESSION_NOT_ALLOWED(옛 서버 공용 비밀번호 거절)는 비밀번호 틀림 문구
        // SUPPORT_ACCOUNT_LOGIN_DENIED·ACCOUNT_INACTIVE 등 새 계약 코드는 공통 문구(W6 E2)
        const standard = standardErrorNotice(error);
        this.loginError =
          errorCode(error) === "SESSION_NOT_ALLOWED"
            ? SHARED_PASSWORD_LOGIN_MESSAGE
            : standard
            ? standard.text
            : errorMessage(
                error,
                error.response && error.response.status === 400
                  ? "접근 권한이 없습니다."
                  : "로그인에 실패하였습니다."
              );
      }
    },

    // 토큰 저장 후 대시보드로. 증표(mfaToken)는 2단계·등록을 통과했거나 2FA 예외일 때만 온다
    async completeLogin(data) {
      await openDialog("로그인에 성공하였습니다.", "success", "확인");
      clearMfaToken();
      // 새로 로그인하면 권한 재검토를 다시 묻고, 그 전 로그인에서 보낸 응답은 버림(T-CONTRACT-1031 §2)
      resetAsked(sessionStorage);
      nextLoginGeneration();
      localStorage.setItem("accessTokenCerti", data.accessToken);
      localStorage.setItem("refreshTokenCerti", data.refreshToken);
      setMfaToken(data.mfaToken);
      await this.getUserInfo();
      this.$router.push({ name: "dashboard" });
    },

    startTwoFactor(data) {
      const methods = usableMethods(data.availableMethods);
      if (!methods.length) {
        this.loginError = "이 화면에서 쓸 수 있는 2차 인증 수단이 없습니다. 다른 운영자에게 「2차 인증 초기화」를 요청하세요.";
        return;
      }
      this.twoFactor = {
        token: data.twoFactorToken,
        methods,
        targets: { ALIMTALK_OTP: data.phoneMasked, FALLBACK_EMAIL_OTP: data.emailMasked },
        enroll: false,
      };
    },

    // 첫 로그인 등록(A12·A13): 수단을 고르고 새 번호·이메일로 받은 인증번호를 확인하면 로그인 완료
    startEnroll(data) {
      const methods = usableMethods(data.availableMethods || ["ALIMTALK_OTP", "FALLBACK_EMAIL_OTP"]);
      this.twoFactor = { token: data.enrollToken, methods, targets: {}, enroll: true };
    },

    // twoFactorToken(5분)·enrollToken(10분)으로 부르는 로그인 단계 API. 401 이면 토큰이 만료된 것이라 처음부터 다시
    async twoFactorCall(path, body) {
      const tokenKey = this.twoFactor.enroll ? "enrollToken" : "twoFactorToken";
      try {
        const response = await this.$apiInstance.post(
          path,
          { [tokenKey]: this.twoFactor.token, ...body },
          { showGlobalLoading: false }
        );
        return response.data;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.cancelTwoFactor();
          this.loginError = "인증 시간이 지났습니다. 처음부터 다시 로그인하세요.";
        }
        throw error;
      }
    },

    sendTwoFactorCode(method, target) {
      return this.twoFactor.enroll
        ? this.twoFactorCall("/auth/2fa/enroll/challenge", { method, target })
        : this.twoFactorCall("/auth/2fa/challenge", { method });
    },

    // 등록 확인(A13) 응답은 /auth/2fa/verify 와 같은 모양이라 같은 로그인 완료 처리
    async verifyTwoFactorCode(method, code) {
      const path = this.twoFactor.enroll ? "/auth/2fa/enroll/verify" : "/auth/2fa/verify";
      const data = await this.twoFactorCall(path, { method, code });
      await this.completeLogin(data);
    },

    cancelTwoFactor() {
      this.twoFactor = null;
      this.password = "";
    },

    // 로그인 성공 시 정보 가져오기
    async getUserInfo() {
      const userId = jwtDecoder(localStorage.getItem("accessTokenCerti"));
      const response = await this.$apiInstance.get(`/companies/${userId}`);
      if(response.status === 200 || response.status === 201) {
        const {data} = response;
        this.$store.dispatch("setUserInfo", {
          userName: data.accountInfo.username, 
          userImageUrl: data.imgUrl,
        })
        localStorage.setItem("userNameCerti", data.accountInfo.username);
        localStorage.setItem("userImageUrlCerti", data.imgUrl);
      }
    },

    // 엔터 눌렀을 때 실행
    enter() {
      if (window.event.keyCode === 13) {
        this.signIn();
      }
    },
  }
};
</script>
<style>
  main {
    overflow: hidden;
    padding-left: 0!important;
  }

  .signinBox {
    background-color: transparent;
    box-shadow: none!important;
    padding: 4vw 1vw;
    box-sizing: border-box;
  }

  .loginResult {
    color: #C64B4B;
    font-size: 0.875rem;
    white-space: pre-line;
  }

  .failArea {
    background: #F2DEDE;
    color: #C64B4B;
    font-size: 20px;
    width: 100%;
    height: 45px;
    text-align: center;
    line-height: 45px;
    opacity: 0;
  }

  .succArea {
    background: #DCE9D5;
    color: green;
    font-size: 20px;
    width: 100%;
    height: 45px;
    text-align: center;
    line-height: 45px;
    opacity: 0;
  }
  
  .visible {
    animation-name: snackbar-animation;
    animation: snackbar-animation 3s ease-out;
    animation-fill-mode: forwards;
  }
  
  @keyframes snackbar-animation {
    0% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  .loginInput {
    background-color: red;
    height: 49px;
    padding: 0.75rem 0.75rem;
    font-size: 0.875rem;
    border-radius: 0.5rem;
    display: block;
    width: 100%;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.4rem;
    color: black;
    background-color: #D9D9D9;
    background-clip: padding-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0.5rem;
    transition: box-shadow 0.15s ease, border-color 0.15s ease;
    border: none;
  }

  .loginInput::placeholder {
    color: black;
  }

  .newbg.newbg-fit {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  /* 2단계(인증번호) — 위 ID·PW 칸과 같은 모양(회색 바탕·49px·둥근 0.5rem, M8) */
  .signin-otp-title {
    margin-bottom: 6px;
    font-size: 1rem;
    font-weight: 700;
    color: #17191c;
  }
  .signin-otp-user {
    margin-left: 6px;
    font-size: 0.875rem;
    font-weight: 400;
    color: #4b5158;
  }
  .signin-otp-desc {
    margin-bottom: 16px;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #2f3337;
  }
  .signin-otp .ant-input {
    height: 49px;
    border: none !important;
    border-radius: 0.5rem;
    background-color: #d9d9d9;
    font-size: 0.875rem;
    color: #17191c;
  }
  .signin-otp .ant-input::placeholder {
    color: #4b5158 !important;
  }
  .signin-otp .ant-input:hover {
    border: none !important;
  }
  .signin-otp .ant-input:focus {
    border: none !important;
    box-shadow: 0 0 0 2px #4b5158 !important;
  }
  .signin-otp .otp-resend,
  .signin-otp .otp-primary,
  .signin-otp-cancel {
    height: 49px;
    border-radius: 0.5rem;
  }
  /* 이 페이지 span 회색 규칙이 버튼 글자까지 흐리게 해 꺼진 버튼처럼 보인다 — 버튼 색을 따르게 */
  .signin-otp .ant-btn span {
    color: inherit;
  }
  .signin-otp-cancel {
    color: #2f3337;
  }
  .signin-otp .otp-methods .ant-radio-button-wrapper {
    height: 44px;
    line-height: 42px;
  }


</style>
<!-- 
  .form-control-lg {
    min-height: unset;
    padding: 0.75rem 0.75rem;
    font-size: 0.875rem;
    border-radius: 0.5rem;
}
 -->
 <!-- 
  .form-control {
    display: block;
    width: 100%;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.4rem;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #d2d6da;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0.5rem;
    transition: box-shadow 0.15s ease, border-color 0.15s ease;
}
  -->